type SpeckleDialogHandlers = {
  onMessage?: (message: string) => void;
  onClose?: () => void;
};

const DIALOG_HEIGHT_PERCENT = 70;
const DIALOG_WIDTH_PERCENT = 40;

export function openSpeckleDialog(url: string, handlers: SpeckleDialogHandlers = {}): void {
  if (typeof Office === "undefined" || !Office.context?.ui?.displayDialogAsync) {
    console.error("The Office dialog API is not available.");
    handlers.onClose?.();
    return;
  }

  Office.context.ui.displayDialogAsync(
    url,
    { height: DIALOG_HEIGHT_PERCENT, width: DIALOG_WIDTH_PERCENT, displayInIframe: false },
    (asyncResult) => {
      if (asyncResult.status !== Office.AsyncResultStatus.Succeeded || !asyncResult.value) {
        console.error("Failed to open Speckle dialog", asyncResult.error);
        handlers.onClose?.();
        return;
      }

      const dialog = asyncResult.value;

      dialog.addEventHandler(Office.EventType.DialogMessageReceived, (event) => {
        const { message } = event as { message: string };

        handlers.onMessage?.(message);
        try {
          dialog.close();
        } catch {
          console.info("Speckle dialog was already closed.");
        } finally {
          handlers.onClose?.();
        }
      });

      dialog.addEventHandler(Office.EventType.DialogEventReceived, () => {
        handlers.onClose?.();
      });
    }
  );
}
